export const NOT_FOUND_VIEW_EN = {
  notFoundError: 'Error: Page not found',
  notFoundDescription:
    "Sorry, we couldn't find the page you were looking for. Click the back to home button to start a new journey!",
  backToHome: 'Back to Home'
}

export const NOT_FOUND_VIEW_DE = {
  notFoundError: 'Fehler: Seite nicht gefunden',
  notFoundDescription:
    'Leider konnten wir die gesuchte Seite nicht finden. Klicken Sie auf den Button, um zur Startseite zurückzukehren!',
  backToHome: 'Zurück zur Startseite'
}
